import React from "react"
import style from './aboutOhCleo.module.css'
import Img from 'gatsby-image'

export default function AboutOhCleo({ section }) {
console.log(section.images[0].fluid)
    return (
        <div className={style.container}>
            <div>
                <span className="caption">{section.overline}</span>
                <h2>{section.title}</h2>
                <h4>{section.subTitle}</h4>
                <p>
                    {section.body1}<br/><br/>
                    {section.body2}
                </p>
            </div>
            <div>
            {section && section.images ? <Img fluid={section.images[0].fluid} alt={'App Promo'}></Img>  :  <img src={"/images/illustrated-girl.svg"} alt="Illustrated girl" />}
            </div>
        </div>
    )
}